import { Spacer } from '../../../parts/Spacer';

export const BasicContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <div className="cst-side-space relative mx-auto max-w-256 rounded-3 border border-main-10 bg-base-100">
    <Spacer spacing={12} />
    <div className="cst-side-space mx-auto max-w-180">{children}</div>
    <Spacer spacing={12} />
  </div>
);
